import { cleanAndMatchTyrePattern } from "./stringFormatters";

export const parseTireSizeArrow = (tireSize: string) => {
  if(!tireSize || tireSize === "N/A") {
    return {};
  }
  const match = cleanAndMatchTyrePattern(tireSize);

  if (!match) {
    console.error(`Invalid tire size format. Expected format: 205/65 R16 or similar, got "${tireSize}"`);
    return;
  }

  const width = parseInt(match[1], 10);
  const aspectRatio = parseInt(match[2], 10);
  const construction = match[3].toUpperCase();
  const rimDiameter = parseInt(match[4], 10);

  return {
    width,
    aspectRatio,
    construction,
    rimDiameter,
    original: tireSize.trim(),
    points: [
      aspectRatio && `Has a sidewall height that's ${aspectRatio}% of ${width}mm`,
      `Is a radial tire (${construction})`,
      `Fits on a ${rimDiameter}-inch wheel`,
    ].filter(Boolean),
  };
};
